import { ActionType } from "../action_type";
import { Action } from "../actions/fetchGuildSingleAction";

interface GuildSingleState {
  loading: boolean;
  error: string | null;
  data: {};
}

const initialState = {
  loading: false,
  error: null,
  data: {},
};

const fetchGuildSingleReducer = (state: GuildSingleState = initialState, action: Action) => {
  switch (action.type) {
    case ActionType.FETCH_GUILD_SINGLE:
      return { loading: true, error: null, data: {} };
    case ActionType.FETCH_GUILD_SINGLE_SUCCESS:
      return { loading: false, error: null, data: action.payload };
    case ActionType.FETCH_GUILD_SINGLE_ERROR:
      return { loading: false, error: action.payload, data: {} };
    default:
      return state;
  }
};

export default fetchGuildSingleReducer;
